import { Component,HostListener } from '@angular/core';
// import { SwUpdate } from '@angular/service-worker';
import { MessagingService } from './service/messaging.service';
import {Router} from '@angular/router'
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

import { AuthenticationService } from '../app/core/services/authentication.service';
import { AppService } from './app.service';
import Swal from 'sweetalert2';
import { PingBshpService } from './service/ping-bshp.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  title = 'TL-Broker-Self-Help-Portal';
  message;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = new Date();
  title1 = 'angular-idle-timeout';
  loggedInuser: string;
  showPopup: boolean=false;
  constructor(private messagingService: MessagingService, private router: Router,private idle: Idle, private keepalive: Keepalive,public authenticationService:AuthenticationService, private appService: AppService,private pingService: PingBshpService) {
  // sets an idle timeout of 900 seconds, for testing purposes.
  idle.setIdle(900);
  // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
  idle.setTimeout(5);
  // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
  idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

  idle.onIdleEnd.subscribe(() => {
    
    this.idleState = 'No longer idle.';
    console.log(this.idleState);
    this.reset();
  });

  idle.onTimeout.subscribe(() => {
    // this.childModal.hide();
    this.idleState = 'Timed out!';
    this.timedOut = true;
    console.log(this.idleState);
    this.logout()
  });

  idle.onIdleStart.subscribe(() => {
    this.idleState = "You've gone idle!";
    console.log(this.idleState);
    // this.childModal.show();
  });

  idle.onTimeoutWarning.subscribe((countdown) => {
    this.idleState = 'You will time out in ' + countdown + ' seconds!';
    console.log(this.idleState);
  });

  // sets the ping interval to 15 seconds
   keepalive.interval(5);

//  keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
 keepalive.onPing.subscribe(() => {
  const timeDifference = Date.now() - this.pingService.lastPing.getTime();

// Define the threshold for 15 minutes in milliseconds
const fifteenMinutesInMilliseconds = 15 * 60 * 1000;

// Check if the time difference is greater than or equal to 15 minutes
if (timeDifference >= fifteenMinutesInMilliseconds) {
  console.log('Current time is 15 minutes or more ahead of the last ping.');
  Swal.fire({
    title: "Your session has logged out due to inactivity. Please re-login.",
    
    backdrop: false, // Set to false to disable outside click closing
    allowOutsideClick: false, // Set to false to disable outside click closing
    confirmButtonText: "Ok",
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      this.logout()
    } 
  });
 
} else {
  console.log('Current time is within the 15-minute threshold.');
}
this.pingService.lastPing = new Date();
  console.log('Ping received. Last ping:', this.pingService.lastPing);
});

  this.appService.getUserLoggedIn().subscribe((userLoggedIn) => {
    if (userLoggedIn) {
      idle.watch();
      this.timedOut = false;
    } else {
      idle.stop();
    }
  });
  
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  stay() {
    // this.childModal.hide();
    this.reset();
  }
  
  logout() {
    this.appService.setUserLoggedIn(false);
    // this.childModal.hide();
    // this.appService.setUserLoggedIn(false);
    // this.router.navigate(['/']);
    this.authenticationService.logout();
  }
  ngOnInit() {
      
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage;

    // if (this.swUpdate.isEnabled) {

    //   this.swUpdate.available.subscribe(() => {

    //     if (confirm("New version available. Load New Version?")) {

    //       window.location.reload();
    //     }
    //   });
    // }
  }
  
 
}
